<template>
  <div class="container">
    <Nav></Nav>
    <div class="index_hearderImg">
      <img src="../assets/qingye/TechnicalServices.png" alt="" />
    </div>
    <div class="breadcrumb_center">
      <el-breadcrumb
        class="el-icon-arrow-right"
        separator-class="el-icon-arrow-right"
      >
        <img src="../assets/qingye/indexImg.png" alt="" />
        <div>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>技术服务</el-breadcrumb-item>
          <el-breadcrumb-item>{{ tabName }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <div class="information index_center">
      <div class="information_right">
        <div class="information_left">
          <div class="TechnicalBar">
            <el-menu
              class="el-menu-vertical-demo"
              @select="tabClick"
              :default-active="tabIndex"
              mode="horizontal"
              active-text-color="#2968BD"
            >
              <el-menu-item
                :index="item.id + ''"
                v-for="(item, index) in serviceTypeList"
                :key="index"
                @click="ChangeItem(index)"
              >
                <span slot="title">{{ item.serviceType }}</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
        <div class="CloudService">
          <div class="CloudService_title">
            <el-divider>
              <div class="CloudService_title_name">{{ tabName }}</div>
            </el-divider>
          </div>
          <div class="CloudService_content">
            <span v-html="content"></span>
          </div>
        </div>
      </div>
      <SubmitFrom></SubmitFrom>
    </div>

    <Foot style="margin-top: 120px" @goRouter="goRouter"></Foot>
  </div>
</template>
<script>
import Nav from "./components/navBar";
import Foot from "./components/Foot";
import SubmitFrom from "./components/SubmitFrom";

import { getServiceTypeApi, getServiceInfoApi } from "@/api/index";

export default {
  components: {
    Nav,
    Foot,
    SubmitFrom,
  },
  name: "Information",
  data() {
    return {
      tabIndex: 1,
      serviceTypeList: [],
      content: "",
      tabName: "",
      temp: false,
    };
  },
  created() {
    this.getServiceType();
  },
  mounted() {
    this.$cookies.set("tabbar", 2);
    this.$store.state.tabbar = this.$cookies.get("tabbar");
  },
  beforeUpdate() {
    //接收参数index
    if (!this.temp) {
      this.tabIndex = this.$route.query.index || 1;
    }
    if (this.tabIndex == 1) {
      this.tabName = "云服务";
    } else if (this.tabIndex == 2) {
      this.tabName = "软件定制";
    } else if (this.tabIndex == 3) {
      this.tabName = "集成系统";
    } else {
      this.tabName = "解决方案";
    }
    this.getServiceInfo();
  },
  updated() {},
  methods: {
    goRouter(index) {
      console.log(index);
      if (index == 1) {
        this.tabIndex = 1;
        console.log(111);
      } else if (index == 2) {
        this.tabIndex = 2;
        console.log(222);
      } else if (index == 3) {
        this.tabIndex = 3;
        console.log(333);
      } else {
        this.tabIndex = 4;
        console.log(444);
      }
      this.getServiceInfo();
    },
    tabClick(key) {
      console.log(key);
      console.log((this.tabIndex = key));
      // this.getServiceInfo()
    },
    //serve页面点击修改文字
    ChangeItem(index) {
      this.temp = true;
      this.tabName = this.serviceTypeList[index].serviceType;
      this.tabIndex = index + 1;
      console.log(this.tabIndex);
    },
    //获取服务类型
    getServiceType() {
      getServiceTypeApi().then((res) => {
        console.log(res);
        this.serviceTypeList = res.data;
        if (this.$route.query.tabIndex) {
          this.tabIndex = this.$route.query.tabIndex;
          this.tabName = this.$route.query.tabName;
        } else {
          this.tabIndex = this.serviceTypeList[0].id + "";
          this.tabName = this.serviceTypeList[0].serviceType;
        }
        // this.getServiceInfo()
      });
    },
    //获取服务详情
    getServiceInfo() {
      var data = {
        type: this.tabIndex,
      };
      getServiceInfoApi(data).then((res) => {
        console.log(res);
        this.content = res.data.content;
      });
    },
  },
};
</script>
<style scoped>
.index_center {
  width: 1200px;
  /*width: 1360px;*/
  margin: 0 auto;
}

.information {
  /*margin-top: 70px;*/
  display: flex;
}

.information_left {
  /*width: 140px;*/
  padding-top: 120px;
}

.information_right {
  padding-top: 60px;
  display: flex;
  justify-content: center;
  width: 1200px;
}

.index_hearderImg {
  display: flex;
  justify-content: center;
}

.index_hearderImg img {
  width: 100%;
}

.breadcrumb_center {
  width: 100%;
  background-color: #f6f7f8;
  display: flex;
  justify-content: space-around;
  height: 50px;
}

.el-icon-arrow-right {
  display: flex;
  align-items: center;
  /*width: 1360px;*/
  width: 1200px;
  color: #666666;
}

.el-icon-arrow-right img {
  padding: 0 10px 0px 0;
}

div /deep/ .el-breadcrumb__inner.is-link {
  font-weight: normal;
  color: #606266;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el_form {
  width: 700px;
}

div /deep/ .el-textarea__inner {
  height: 200px;
  width: 495px;
}

.CloudService {
  padding-left: 65px;
  width: 100%;
}

.CloudService_title {
  /*font-size: 28px;*/
  /*font-weight: 600;*/
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-bottom: 70px;
  /*width: 1025px;*/
  width: 100%;
}

.CloudService_title_name {
  font-size: 28px;
  text-align: center;
  font-weight: 600;
}

.CloudService_title_text {
  font-size: 14px;
  text-align: center;
}
.CloudService_content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.CloudService_content_span {
  width: 730px;
  padding: 28px 0;
  line-height: 24px;
}
.CloudService_content_img {
  width: 730px;
  height: 410px;
}

.CloudService_content_img img {
  width: 100%;
  height: 100%;
}

.TechnicalBar >>> .el-menu--horizontal > .el-menu-item.is-active {
  border-right: 2px solid #2968bd;
  border-bottom: none;
  /*background-color: red;*/
  background-image: linear-gradient(to right, #ffffff, rgba(41, 104, 189, 0.1));
}

.TechnicalBar >>> .el-menu--horizontal > .el-menu-item {
  border-bottom: none;
  /*text-align: center;*/
  width: 140px;
}

.TechnicalBar >>> .el-menu.el-menu--horizontal {
  border-bottom: none;
  /*border-right: 1px solid #E5E5E5;*/
  display: flex;
  flex-direction: column;
  align-items: end;
}
</style>



// WEBPACK FOOTER //
// src/views/service.vue